export default __webpack_public_path__ + "static/media/six-step-sales-icon.5c2627b7.png";